import React from 'react';

// Format currency values
const formatCurrency = (value) => {
  if (value === null || value === undefined) return 'N/A';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
};

function FinancialSummary({ budget, totalPayments, remainingBudget }) {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex justify-between">
        <span>Total Budget:</span>
        <span className="font-medium">{formatCurrency(budget)}</span>
      </div>
      <div className="flex justify-between">
        <span>Total Payments:</span>
        <span className="font-medium">{formatCurrency(totalPayments)}</span>
      </div>
      <div className="flex justify-between border-t pt-2">
        <span>Remaining Budget:</span>
        <span className={`font-medium ${remainingBudget < 0 ? 'text-red-500' : ''}`}>
          {formatCurrency(remainingBudget)}
        </span>
      </div>
    </div>
  );
}

export default FinancialSummary;